import { useState, useEffect } from 'react'

const useInViewId = (ids: string[]) => {
  const [currentId, setCurrentId] = useState<string | undefined>(undefined)

  useEffect(() => {
    const handleScroll = () => {
      const viewportHeight = window.innerHeight
      const triggerPosition = viewportHeight * 0.15

      for (const id of ids) {
        const element = document.getElementById(id)
        if (element) {
          const rect = element.getBoundingClientRect()

          if (rect.top >= 0 && rect.top <= triggerPosition) {
            setCurrentId(id)
            break
          }
        }
      }
    }

    window.addEventListener('scroll', handleScroll)
    window.addEventListener('resize', handleScroll)

    // Initial check in case the section is already in view on mount
    handleScroll()

    return () => {
      window.removeEventListener('scroll', handleScroll)
      window.removeEventListener('resize', handleScroll)
    }
  }, [ids])

  return currentId
}

export default useInViewId
